import Vue from 'vue'

require('./components/index.js')

var App = new Vue({
	el : '#app',
	data : function(){
		return {}
	}
});


// WEBPACK FOOTER //
// ./src/assets/vue/main.js